import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'

import type { Location } from '../types'

type LocationCardProps = Pick<Location, 'title' | 'image' | 'hotelCode' | 'classification'> & {
	onSelect: (hotelCode: string) => void
	isSummary?: boolean
}

export const LocationCard = ({
	title,
	hotelCode,
	classification,
	image,
	isSummary,
	onSelect,
}: LocationCardProps) => {
	return (
		<article
			data-hotelCode={hotelCode}
			tabIndex={0}
			onKeyDown={(e) => e.key === 'Enter' && onSelect(hotelCode)}
			role={isSummary ? 'article' : 'button'}
			onClick={() => onSelect(hotelCode)}
			className={cn(
				'flex gap-16',
				'md:flex-col md:gap-16  md:rounded-locationCardDesktop md:bg-naturel',
				!isSummary && 'cursor-pointer',
				!isSummary && 'transition-transform duration-500 ease-in-out md:hover:scale-[1.03]',
				isSummary && 'md:bg-locationCard-summary'
			)}
		>
			<img
				className={cn(
					'aspect-square max-w-[80px] rounded-locationCard object-cover',
					'md:aspect-auto md:h-[310px] md:max-w-full md:rounded-b-0 md:rounded-t-locationCardDesktop',
					isSummary && 'md:aspect-[2.3/1]'
				)}
				src={image.largeUrl}
				alt={image.alt}
				title={image.title}
			/>
			<div
				className={cn(
					'flex flex-col items-start justify-center gap-8 text-naturel',
					'md:flex-row md:items-center md:justify-between md:gap-0 md:p-16 md:pt-0 md:text-locationCard-text'
				)}
			>
				<Typography
					style="p-s-bold"
					element="h3"
					className={cn(
						'order-2',
						'md:order-1',
						'text-textColor md:text-locationCard-text'
					)}
				>
					{title}
				</Typography>
				<div
					className={cn(
						'order-1 rounded-24 bg-locationCard-classification px-16 pb-8 pt-6 md:bg-transparent md:p-0 md:text-locationCard-text',
						'md:order-2'
					)}
				>
					<Typography style="p-s">{classification?.name}</Typography>
				</div>
			</div>
		</article>
	)
}
